export default "__VITE_ASSET__C6C$1fvQ__"